
<div class="modal-header">
  <h4 class="modal-title pull-left">{{actionLabel}}</h4>
  <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="onCloseModal()">
    <span aria-hidden="true" class="visually-hidden">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form class="row g-0" [formGroup]="form" (ngSubmit)="salvar()" (keydown.enter)="$event.preventDefault()">
    <div class="col-md-12">
      <label>Título: <sup class="text-danger">*</sup></label>
      <input class="form-control" formControlName="title">
      <app-field-message [field]="fieldMessageRequired('title')" [erros]="fieldErros('title')"></app-field-message>
    </div>
    <div class="col-md-12" *ngIf="type == 'group'">
      <label>Descrição: </label>
      <textarea class="form-control" formControlName="description"></textarea>
      <app-field-message [field]="fieldMessageRequired('description')" [erros]="fieldErros('description')"></app-field-message>
    </div>
    <div class="col-md-12" *ngIf="type == 'item'">
      <label>Tempo estimado de leitura ou vídeo: </label>
      <textarea class="form-control" formControlName="time"></textarea>
      <app-field-message [field]="fieldMessageRequired('time')" [erros]="fieldErros('time')"></app-field-message>
    </div>
    <div class="col-md-12" *ngIf="type == 'item'">
      <label class="col-12">Arquivo do tutorial:</label>
      <input type="file" id="file" class="form-control" formControlName="file" (change)="onFileSelected($event)" [required]="!entity"/>
      <app-field-message [field]="fieldMessageRequired('description')" [erros]="fieldErros('description')"></app-field-message>
    </div>
    <div class="hr-line-dashed"></div>
    <div class="form-group row d-flex justify-content-end">
      <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
        <button class="btn btn-white m-r-xs" type="button" (click)="onCloseModal()">Cancelar</button>
        <button class="btn btn-primary" type="submit">Salvar</button>
      </div>
    </div>
  </form> 
</div>
<app-loading [loader]="isLoading"></app-loading>